import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AddToHomescreenButton from "../features/addToHomeScreen";
import NavBar from "../features/NavBar";
import {
  CINEMA_HALL_PAGE,
  FINALIZE_PAGE,
  LOGIN_PAGE,
  MOVIE_DETAILS_PAGE,
  NEWS_PAGE,
  REGISTRATION_PAGE,
  REGISTRATION_SUCCESS_PAGE,
  REMIND_PASS_PAGE,
  SALE_FOOD_PAGE,
  SALE_MOVIE_PAGE,
} from "./routes";
import Login from "./components/Login";
import MyAccount from "./components/MyAccount";
import RemindPass from "./components/RemindPass";
import Registration from "./components/Registration";
import RegistrationSuccess from "./components/Registration/RegistrationSuccess";
import useAuth from "./components/Login/hooks/useAuth";
import Footer from "../features/Footer";
import SaleMovie from "./components/SaleMovie";
import useDesktopSize from "../utils/hooks/useDesktopSize";
import MovieDetails from "./components/SaleMovie/MovieDetails";
import CinemaHall from "./components/SaleMovie/CinemaHall";
import FinalizePage from "./components/FinalizePage";
import SaleFood from "./components/SaleFood/SaleFood";
import NewsPage from "./components/NewsPage";

const publicUrl = process.env.PUBLIC_URL;
const CompletedTasksUrl = publicUrl + "/completed";

interface IProps {
  title: string;
  status: string;
}

const Template: React.FC<IProps> = (props: IProps) => (
  <div style={{ marginLeft: "15vw" }}>
    <p className="page-info">Strona będzie dostępna później</p>
    {/*<ul className={props.status}>*/}
    {/*  <li>Task 1</li>*/}
    {/*  <li>Task 2</li>*/}
    {/*  <li>Task 3</li>*/}
    {/*</ul>*/}
    <AddToHomescreenButton />
  </div>
);

const CompletedTasks: React.FC = () => <Template title="Completed Tasks" status="Completed" />;

const MainApp: React.FC = () => {
  const { isLoggedIn } = useAuth();
  const isDesktop = useDesktopSize();
  return (
    <BrowserRouter>
      <NavBar />
      <div style={isDesktop ? { margin: "120px" } : { marginTop: "100px" }}>
        <Routes>
          <Route path={SALE_MOVIE_PAGE} element={<SaleMovie />} caseSensitive />
          <Route path={CompletedTasksUrl} element={<CompletedTasks />} />
          <Route path={LOGIN_PAGE} element={isLoggedIn ? <MyAccount /> : <Login />} />
          <Route path={REMIND_PASS_PAGE} element={<RemindPass />} />
          <Route path={REGISTRATION_PAGE} element={<Registration />} />
          <Route path={REGISTRATION_SUCCESS_PAGE} element={<RegistrationSuccess />} />
          <Route path={MOVIE_DETAILS_PAGE} element={<MovieDetails />} />
          <Route path={CINEMA_HALL_PAGE} element={<CinemaHall />} />
          <Route path={FINALIZE_PAGE} element={<FinalizePage />} />
          <Route path={SALE_FOOD_PAGE} element={<SaleFood />} />
          <Route path={NEWS_PAGE} element={<NewsPage />} />
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
};

export default MainApp;
